var exports = {
  "CR": "CustomStatusModal.module__modalRoot___RzF3LX",
  "_l": "CustomStatusModal.module__previewSection___RzF3LX",
  "uG": "CustomStatusModal.module__statusInputWrapper___RzF3LX",
  "Dq": "CustomStatusModal.module__characterCount___RzF3LX",
  "DY": "CustomStatusModal.module__emojiTriggerButton___RzF3LX",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___RzF3LX",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___RzF3LX",
  "J7": "CustomStatusModal.module__clearButtonIcon___RzF3LX",
  "qr": "CustomStatusModal.module__footer___RzF3LX",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___RzF3LX",
  "uD": "CustomStatusModal.module__expirationLabel___RzF3LX",
  "S2": "CustomStatusModal.module__expirationSelect___RzF3LX",
};

module.exports = exports;
